// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3h6m5","left":"InfoRow_left__MUh6k"};